import { useState } from 'react';
import AscendingK from './AscendingK';
import { Icons } from './Icons';
import { nameToSlug } from '../utils/validation';
import { apiRequest } from '../lib/api';
import { getPublicCardUrl, getPublicBaseUrl } from '../lib/site';
import { getPocQrPageUrl } from '../lib/poc-qr';

export default function SharePopup({ user, onClose }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = getPublicCardUrl(user.slug || nameToSlug(user.name));
  const shareText = `I just created my free digital business card on Connekted.in! Scan my QR code or visit ${shareUrl}`;
  const qrFrameUrl = user.photo
    ? getPocQrPageUrl({ photoUrl: user.photo, targetUrl: shareUrl })
    : '';

  const handleShare = (platform) => {
    apiRequest('/users/me/referrals/share', { method: 'POST', body: { platform } }).catch(() => {});
    let url;
    switch (platform) {
      case 'instagram':
        url = 'https://www.instagram.com/';
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getPublicBaseUrl())}&quote=${encodeURIComponent(shareText)}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(getPublicBaseUrl())}`;
        break;
      default:
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer,width=600,height=500');
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      apiRequest('/users/me/referrals/share', { method: 'POST', body: { platform: 'copy' } }).catch(() => {});
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal share-popup" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 460 }}>
        <div className="modal-header" style={{ borderBottom: 'none', paddingBottom: 0 }}>
          <span />
          <button className="btn btn-ghost-app" onClick={onClose}>{Icons.close}</button>
        </div>

        <div className="modal-body" style={{ textAlign: 'center', paddingTop: 0 }}>
          <div className="share-celebration">
            <span className="share-emoji">🎉</span>
          </div>
          <h2 className="serif" style={{ fontSize: 28, fontWeight: 400, marginBottom: 8, color: 'var(--ink)' }}>
            Your card is <em style={{ color: 'var(--brand)' }}>live</em>!
          </h2>
          <p style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 24, lineHeight: 1.6 }}>
            Time to make it viral. Share your QR code on social media and let your network know.
          </p>

          <div className="share-qr-preview">
            <div className="share-qr-placeholder">
              <div
                style={{
                  width: 180,
                  height: 180,
                  background: 'var(--paper-warm)',
                  borderRadius: 'var(--r-md)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  margin: '0 auto',
                  overflow: 'hidden'
                }}
              >
                {qrFrameUrl ? (
                  <iframe
                    title="Share QR"
                    src={qrFrameUrl}
                    style={{ width: '100%', height: '100%', border: 'none', background: 'white' }}
                  />
                ) : (
                  <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 10, color: 'var(--muted)', textAlign: 'center', padding: 16 }}>
                    Upload a profile photo to generate your portrait QR.
                  </div>
                )}
                <div style={{ position: 'absolute', bottom: 6, right: 6 }}>
                  <AscendingK size={12} color="#D4CFC2" />
                </div>
              </div>
            </div>
            <p className="mono" style={{ marginTop: 8, fontSize: 9 }}>
              QR points to your scan page: {shareUrl} · Uses your saved profile photo
            </p>
          </div>

          <div className="share-buttons">
            <button className="share-social-btn share-instagram" onClick={() => handleShare('instagram')}>
              <span>Instagram</span>
            </button>
            <button className="share-social-btn share-facebook" onClick={() => handleShare('facebook')}>
              <span>Facebook</span>
            </button>
            <button className="share-social-btn share-linkedin" onClick={() => handleShare('linkedin')}>
              <span>LinkedIn</span>
            </button>
          </div>

          <div className="share-copy-row">
            <input className="form-input" value={shareUrl} readOnly style={{ fontSize: 13, textAlign: 'center' }} />
            <button className="btn btn-outline btn-sm" onClick={handleCopyLink}>
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>

          <button className="btn btn-ghost-app" onClick={onClose} style={{ marginTop: 16, fontSize: 13 }}>
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
